( function () {
	'use strict';
	/* globals angular */

	function reportTemplatesFactory ( apiService, moment, _ ) {
		var obsTemplates, fetchedTemplates, fetchedTemplatesAll;

		function filterTemplates ( template ) {
			return obsTemplates.filter( function ( obsTemplate ) {
				return ( obsTemplate || {} ).id === template.id;
			} ).length;
		}

		function storeFetchedTemplates ( res ) {
			fetchedTemplates = res;
		}

		function storeFetchedTemplatesAll ( res ) {
			fetchedTemplatesAll = res;
		}

		function hasRubric ( item ) {
			return !item.rubric;
		}

		function transformTagsObject ( item ) {
			return {
				'name' : item.toString()
			};
		}

		function filterTags ( template ) {
			( template.tags || [] ).unshift( { 'Type' : template.types || [] } );
			return template.tags;
		}

		function addDate ( item ) {
			return {
				'id'        : item.id,
				'name'      : item.name,
				'createdAt' : moment( item.createdAt ).format( 'MM/DD/YY' ),
				// this is for proficiency trend report
				'noRubric'  : hasRubric( item ),
				'tags'      : filterTags( item )
			};
		}

		function getFilteredTemplates ( templates ) {
			obsTemplates = templates;

			return fetchedTemplates
					// filter templates according to observation templates
					.filter( filterTemplates )
					// restructure data, include created date
					.map( addDate );
		}

		function getTemplates () {
			return apiService.getTemplatesForReports.query().$promise;
		}

		function findInArray ( item ) {
			return item.id === this.templateId;
		}

		function filterFromOtherTemplates ( template ) {
			return !fetchedTemplates.filter( findInArray.bind( { 'templateId' : template.id } ) ).length;
		}

		function combineTemplates () {
			var filtered     = fetchedTemplatesAll.filter( filterFromOtherTemplates );

			fetchedTemplates = fetchedTemplates.concat( filtered );
		}

		function extractTags ( templates ) {
			var arr = [];

			templates.forEach( function ( item ) {
				arr = arr.concat( item.tags );
			} );

			return _.uniq( arr )
				.map( transformTagsObject );
		}

		return {
			'getTemplates'             : getTemplates,
			'storeFetchedTemplates'    : storeFetchedTemplates,
			'getFilteredTemplates'     : getFilteredTemplates,
			'storeFetchedTemplatesAll' : storeFetchedTemplatesAll,
			'combineTemplates'         : combineTemplates,
			'extractTags'              : extractTags,
			'filterTags'               : filterTags
		};
	}

	angular.module( 'app.report' )
		.factory( 'reportTemplatesFactory', reportTemplatesFactory );

	reportTemplatesFactory.$inject = [ 'apiService', 'moment', '_' ];
} )( );
